import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import Gears from '../../gears';

const WelcomeUser = (props) => {
    const { userName } = props;

    return (
        <Fragment>
            <div className="grid-row">
                { userName &&
                  <div className="tablet:grid-col-9">
                      <h1 id="skip" className="indDashboard-welcome pt-3 pb-5">
                          <FormattedMessage id="welcome_user" values={{ userName }}/>
                      </h1>
                  </div>
                }
                <div className="tablet:grid-col-3">
                    <Gears />
                </div>
            </div>
        </Fragment>
    );
};

export default WelcomeUser;